import GenerateArrayField from './GenerateArrayField';

export default GenerateArrayField;
